<template>
  <a role="button" :class="classObject" @click="onClick" :disabled="disabled">
    <slot />
  </a>
</template>

<script>
export default {
    name: 'Button',
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classObject() {
            return {
                'weui-btn': true,
                'weui-btn_primary': this.type === 'primary',
                'weui-btn_default': this.type === 'default',
                'weui-btn_warn': this.type === 'warn',
                'weui-btn_loading': this.loading,
                'weui-btn_disabled': this.disabled,
            };
        },
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/button/Index.vue